import React from 'react';
import propTypes from 'prop-types';
import { SName, SJobTitle, SDescription, SCard } from './style';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'components/Image';
import DynamicReactIcon from 'components/DynamicReactIcon';
import GracefulImage from 'components/GracefulImage';

export const Card = ({
  image,
  name,
  jobTitle,
  description,
  twitter,
  instagram,
  facebook,
  linkedin,
  useGracefulImage = false,
}) => (
  <SCard>
    <GracefulImage
      filename={image}
      imageData={image}
      useDeprecatedImage={!useGracefulImage}
      styles={{ width: '100%', height: '439px', borderRadius: 5 }}
    />
    <SName>{name && name}</SName>
    <SJobTitle>{jobTitle && jobTitle}</SJobTitle>
    <SDescription>{description && description}</SDescription>
    <Row>
      {twitter && (
        <Col xs="2">
          <a href={twitter} target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={20}
              withBackground={false}
              iconVariant="twitter"
            />
          </a>
        </Col>
      )}
      {linkedin && (
        <Col xs="2">
          <a href={linkedin} target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={20}
              withBackground={false}
              iconVariant="linkedin"
            />
          </a>
        </Col>
      )}

      {instagram && (
        <Col xs="2">
          <a href={instagram} target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={20}
              withBackground={false}
              iconVariant="instagram"
            />
          </a>
        </Col>
      )}
      {facebook && (
        <Col xs="2">
          <a href={facebook} target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={20}
              withBackground={false}
              iconVariant="facebook"
            />
          </a>
        </Col>
      )}
    </Row>
    {/*social media*/}
  </SCard>
);

Card.propTypes = {
  image: propTypes.oneOfType([propTypes.string, propTypes.object]),
  useGracefulImage: propTypes.bool,
  name: propTypes.string,
  jobTitle: propTypes.string,
  description: propTypes.string,
  twitter: propTypes.string,
  instagram: propTypes.string,
  linkedin: propTypes.string,
  facebook: propTypes.string,
};

export default Card;
